import React from 'react';
//noinspection NpmUsedModulesInstalled
import { BlockDataForm } from '@plone/volto/components';
import DownloadBlockSchema from './DownloadBlockSchema';

const DownloadBlockDataForm = (props) => {
  const { data, block, onChangeBlock, blocksErrors } = props;
  const schema = DownloadBlockSchema({ ...props });

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
      errors={blocksErrors}
    />
  );
};

export default DownloadBlockDataForm;
